import { useTranslation } from 'next-i18next';
import { memo } from 'react';

import ProgressBar from 'components/ComponentV2/ProgressBar';
import AdditionalBadge from './AdditionalBadge';

import styles from './ProfileProgress.module.scss';

interface ProfileProgressProps {
  percentCompleted: number;
  completedTopics: number;
}

export const ProfileProgress: React.FC<ProfileProgressProps> = memo(
  ({ percentCompleted, completedTopics }: ProfileProgressProps) => {
    const [t] = useTranslation('candidate.profile');

    return (
      <>
        <section className={styles['profile-progress']}>
          <p className={styles.text}>
            {percentCompleted === 100
              ? t('profile-progress.complete')
              : t('profile-progress.title')}
          </p>
          <p className={styles.percentage}>{percentCompleted}%</p>
          <p className={styles.points}>({completedTopics}/6)</p>
        </section>
        <section className={styles['progress-bar']}>
          <ProgressBar
            percentCompleted={percentCompleted}
            showProgressWhen0
            color="Primary"
            className={styles.progress}
          />
        </section>
        <AdditionalBadge />
      </>
    );
  }
);

ProfileProgress.displayName = 'ProfileProgress';
